import React, { useEffect, useState } from 'react';
import {
  Grid,
  styled,
  TextField,
  Paper,
  Button,
  Typography,
  TableRow,
  TableCell,
  DialogActions,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete
} from '@mui/material';
import PageHeader from '../../../components/PageHeader';
import Table from '../../../components/Table';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { Link, useNavigate } from 'react-router-dom';
import { Gate, ShiftType } from '../../../schema/gate';
import { formatTime } from '../../../util';
import IOSSwitch from '../../../components/IOSSwitch';
import DeleteIcon from '@mui/icons-material/Delete';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Box } from '@mui/system';
import GateFromInput from '../../../components/formInput/GateFromInput';
import { api } from '../../../api';
import AreaCodeFromInput from '../../../components/formInput/AreaCodeFromInput';
import { Area } from '../../../schema/area';
import { CircularProgress } from '@mui/material';
import { CardType } from '../../../schema/card';

const tableGateHead = ['ประตู', 'พื่นที่', 'สถานะ', 'เวลาเปิด-ปิด', 'ลบประตู'];
const CreateGateGroup: React.FC = () => {
  const navigate = useNavigate();
  const [name, setName] = useState<string>('');
  const [shiftTypeID, setShiftTypeID] = useState<number>(1);

  const [gateIds, setGateIds] = useState<number[]>([]);

  const [gates, setGates] = useState<Gate[]>([]);
  const [open, setOpen] = useState(false);
  const [filterAreaID, setFilterAreaID] = useState<number | null>(null);

  const [shiftTypeList, setShiftTypeList] = useState<ShiftType[]>([]);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoadingAdd, setIsLoadinAdd] = useState<boolean>(false);

  const [searchKeywordArea, setSearchKeywordArea] = useState<string>('');
  const [areaList, setAreaList] = useState<Area[]>([]);
  const [selectedValueArea, setSelectedValueArea] = useState<Area[]>([]);


  const [cardTypeList, setcardTypeList] = useState<CardType[]>([]);
  const [selectedValuecardType, setSelectedValuecardType] = useState<CardType[]>([]);
  const [nameError, setNameError] = useState(false);

  const removeGateFromGroup = (id: number | null) => {
    if (id != null) {
      const temp = gateIds.reduce<number[]>((result, data) => {
        if (data != id) {
          result.push(data);
        }
        return result;
      }, []);
      setGateIds(temp);
    }
  };
  const addGateToGroup = (id: number | null) => {
    if (id != null) {
      if (!gateIds.find((data) => data == id)) {
        setGateIds([...gateIds, id].sort());
      }
    }
  };
  const handleFormSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (isLoading) {
      return;
    }
    setIsLoading(true);
    api
      .post(`/gate-group`, {
        group_name: name,
        area_id: 59,
        shift_type_id: shiftTypeID,
        gates: gateIds,
        areas: selectedValueArea.map((select_area) => (select_area.id)),
        card_types: selectedValuecardType.map((select_cardType) => (select_cardType.id))
      })
      .then(() => {
        navigate('/gate-group');
      })
      .finally(() => setIsLoading(false));
  };
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (event: React.SyntheticEvent<unknown>, reason?: string) => {
    if (reason !== 'backdropClick') {
      setOpen(false);
    }
  };

  const handleGategroupName = (event:any) => {
    const value = event.target.value;
    const sanitizedValue = value.replace(/[`~!@#$%^&*()_|+=?;:'",<>]/gi, ''); // Regex to remove special characters

    setName(event.target.value)

    // Check if the original value differs from the sanitized value
    if (value !== sanitizedValue) {
        setNameError(true);
    } else {
        setNameError(false);
    }
};

  useEffect(() => {
    if (gateIds.length == 0) {
      setGates([]);
      return;
    }
    const searchParams = new URLSearchParams();
    gateIds.forEach((gate_id) => {
      searchParams.append('id', `${gate_id}`);
    });

    api.get<Gate[]>(`/gate`, { params: searchParams }).then((res) => {
      const { data } = res;
      setGates(data);
    });
  }, [gateIds]);

  useEffect(() => {
    api.get<ShiftType[]>(`/shift_type`).then((res) => {
      const { data } = res;
      setShiftTypeList(data);
    });
    api.get<CardType[]>(`/card_type?has_wpm=true&has_ost=true`).then((res) => {
      const { data } = res;
      setcardTypeList(data)
    });
  }, []);

  useEffect(() => {
    if (searchKeywordArea) {
      const timeOut = setTimeout(() => {
        const searchParams = new URLSearchParams();
        searchParams.set('nameorcode', searchKeywordArea);
        api.get<Area[]>(`/area`, { params: searchParams }).then((res) => {
          const { data } = res;
          setAreaList(data);
        });
      }, 500);
      return () => clearTimeout(timeOut);
    } else {
      api.get<Area[]>(`/area`).then((res) => {
        const { data } = res;
        setAreaList(data);
      });
    }
  }, [searchKeywordArea]);

  return (
    <RootContainer>
      <PageHeader text="เพิ่มกลุ่มประตู" />

      <Button component={Link} to={`/gate-group`} sx={{ my: 3, p: 0 }}>
        <ArrowBackIosIcon />
        กลุ่มประตู
      </Button>

      <Paper>
        <Typography variant="h6" sx={{ px: 2, pt: 2, pb: 1 }}>
          {'เพิ่มข้อมูล'}
        </Typography>
        <Form onSubmit={handleFormSubmit} sx={{ padding: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="ชื่อกลุ่ม"
                variant="outlined"
                placeholder="ชื่อกลุ่ม"
                name="group_name"
                value={name}
                onChange={handleGategroupName}
                autoComplete="off"
              />
              {nameError && <span style={{ color: 'red' }}>ไม่อนุญาตให้ใช้อักษรพิเศษ</span>}
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel>{`ช่วงเวลา เปิด-ปิด`}</InputLabel>
                <Select
                  label={`ช่วงเวลา เปิด-ปิด`}
                  variant="outlined"
                  onChange={(e) => {
                    const parsed = parseInt(e.target.value);
                    if (isNaN(parsed)) {
                      setShiftTypeID(1);
                      return;
                    }
                    setShiftTypeID(parsed);
                  }}
                  value={shiftTypeID != null ? `${shiftTypeID}` : `1`}
                  autoComplete="off"
                  required
                >
                  {shiftTypeList.map((data, index) => (
                    <MenuItem key={index} value={`${data.id}`}>
                      {`${data.open_time?.substring(0, 5)} - ${data.close_time?.substring(0, 5)} (${
                        data.type_name
                      })`}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <Autocomplete
                options={areaList}
                getOptionLabel={(option) => (option?.area_code ? option.area_name + ' (' + option.area_code + ')' : '')}
                renderInput={(params) => (
                  <TextField {...params} label="รหัสพื่นที่" />
                )}
                onChange={(_, value) => setSelectedValueArea(value)}
                value={selectedValueArea}
                onInputChange={(_, newInputValue) => {
                  setSearchKeywordArea(newInputValue);
                }}
                // isOptionEqualToValue={(option, v) => v?.id == option?.id}
                fullWidth
                multiple={true}
              />
            </Grid>
            <Grid item xs={6}>
              <Autocomplete
                options={cardTypeList}
                getOptionLabel={(option) => (option?.type_name ? option.type_name : '')}
                renderInput={(params) => (
                  <TextField {...params} label="ประเภทบัตร" />
                )}
                onChange={(_, value) => setSelectedValuecardType(value)}
                value={selectedValuecardType}
                fullWidth
                multiple={true}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ mt: 2 }}>
                เพิ่มประตูที่อยู่ในกลุ่ม
              </Typography>

              <Table heads={tableGateHead} count={gates.length}>
                {gates.map((data, index) => (
                  <TableRow key={index}>
                    <TableCell align="center">{data.gate_name}</TableCell>
                    <TableCell align="center">{data.area?.area_name}</TableCell>
                    <TableCell align="center">
                      <IOSSwitch checked={data.is_active} disabled />
                    </TableCell>
                    <TableCell align="center">
                      {data.shift_type
                        ? `${data.shift_type?.open_time?.substring(
                            0,
                            5
                          )} - ${data.shift_type?.close_time?.substring(0, 5)} (${
                            data.shift_type?.type_name
                          })`
                        : ''}
                    </TableCell>
                    <TableCell align="center">
                      <Grid container spacing={2} justifyContent="center">
                        <Grid item>
                          <IconButton onClick={() => removeGateFromGroup(data.id)}>
                            <DeleteIcon fontSize="large" color="error" />
                          </IconButton>
                        </Grid>
                      </Grid>
                    </TableCell>
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell colSpan={7} align="center" sx={{ p: 1 }}>
                    <Button
                      variant="outlined"
                      startIcon={<AddCircleIcon />}
                      onClick={handleClickOpen}
                    >
                      เพิ่มประตู
                    </Button>
                  </TableCell>
                </TableRow>
              </Table>
            </Grid>
          </Grid>
          <Grid container columns={2} spacing={2} direction={'row-reverse'}>
            <Grid item>
              <Button type="submit" variant="contained" color="primary" sx={{ marginTop: 4 }} 
              disabled={isLoading || nameError}
               >
                 {isLoading ? (
               <CircularProgress color="primary" size={'1.25rem'} sx={{ mr: 2 }} />
             ) : null}
             {`เพิ่มข้อมูล`}
              </Button>
            </Grid>
          </Grid>
        </Form>
      </Paper>
      <Dialog disableEscapeKeyDown open={open} onClose={handleClose}>
        <DialogTitle>เพิ่มประตูในกลุ่ม</DialogTitle>
        <DialogContent sx={{ px: 2, pb: 0 }}>
          <Box component="form" sx={{ display: 'flex', minWidth: 400, p: 1 }}>
            <GateFromInput value={filterAreaID} onChange={(value) => setFilterAreaID(value)} />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>ยกเลิก</Button>
          <Button
            onClick={(e) => {
              addGateToGroup(filterAreaID);
              setFilterAreaID(null);
              handleClose(e);
            }}
           >
            เพิ่มข้อมูล
          </Button>
        </DialogActions>
      </Dialog>
    </RootContainer>
  );
};

export default CreateGateGroup;

const RootContainer = styled('div')`
  padding: 24px;
`;

const Form = styled('form')`
  display: flex;
  flex-direction: column;
  align-items: end;
`;
